import produce from 'immer'

import { Types } from './actions'

const INITIAL_STATE = {
  activeStep: 0
}

export default function stepperReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.setStep: {
        draft.activeStep = action?.payload?.step || 0
        break
      }
      default:
    }
  })
}
